<template>
	<v-app-bar fixed app :elevation="headerProps.elevation" :height="headerProps.height" :style="!headerProps.atTop ? `${headerProps.getHeaderBackground()}` : 'background: transparent'" id="fixit-no__header" class="toolbar pl-3 pr-3">
		<div style="width: 40px" class="mr-4 d-flex" v-if="isMounted && !$vuetify.breakpoint.mdAndUp && !isNoShowPayment">
			<div v-show="!menu">
				<v-icon id="menu-button" size="40px" :color="!headerProps.atTop && headerProps.layout === 'portal' ? `${headerProps.isProfile ? 'var(--v-primary-base)' : 'var(--v-secondary-base)'}` : headerProps.atTop || (!headerProps.atTop && headerProps.layout !== 'portal') ? useConstrastColors ? 'var(--v-primary-text-base)' : 'primary' : ''" style="cursor: pointer" @click="menu = !menu">fxt-menu</v-icon>
			</div>
			<div v-show="menu">
				<v-icon id="menu-button" size="40px" :color="!headerProps.atTop && headerProps.layout === 'portal' ? `${headerProps.isProfile ? 'var(--v-primary-base)' : 'var(--v-secondary-base)'}` : headerProps.atTop || (!headerProps.atTop && headerProps.layout !== 'portal') ? useConstrastColors ? 'var(--v-primary-text-base)' : 'primary' : ''" style="cursor: pointer" @click="menu = !menu">fxt-close</v-icon>
			</div>
			<v-badge color="transparent" v-model="newRelease" right style="margin: 0px 5px 15px 0px">
				<template v-slot:badge>
					<v-icon color="red" size="23" light v-if="newRelease">new_releases</v-icon>
				</template>
			</v-badge>
		</div>
		<slot name="logo">
			<img src="https://umbraco.test.odindata.no/media/1348/fixit_logo_lilla.png" height="80%" style="object-fit: contain" loading="eager" />
		</slot>
		<v-spacer></v-spacer>
		<v-tabs
			ref="tabs"
			v-show="isMounted && $vuetify.breakpoint.mdAndUp && !isNoShowPayment"
			:value="activeTab"
			right
			background-color="transparent"
			class="align-self-center"
			:class="!headerProps.atTop && headerProps.layout != 'portal' ? 'fixit-no__tabs--alt' : 'fixit-no__tabs'"
			:color="!headerProps.atTop && headerProps.layout === 'portal' ? useConstrastColors ? 'var(--v-primary-text-base)' : 'primary' : headerProps.atTop && headerProps.layout != 'portal' ? '' : 'primary'"
			slider-color="transparent"
			optional
		>
		<v-tab id="tab-button" v-for="(nav, index) in headerProps.items.filter((i) => i.Visible && i.Type == 1)" :key="index" :class="$route.path == nav.Link || (nav.Link.includes('about') && $route.path.includes('about') || nav.Link.includes('nettbutikk') && $route.path.includes('nettbutikk')) ? 'fixit-no__tabs_item--active' : ''" class="pa-0 fixit-no__tabs_item" @click="navigationAction(nav)">
				<a :class="'fill-height px-4 d-flex'" :style="`color: ${!headerProps.atTop && headerProps.layout === 'portal' ? `${headerProps.isProfile ? 'var(--v-primary-base)' : 'var(--v-secondary-base)'}` : !headerProps.atTop && headerProps.layout != 'portal' && !$route.path.includes('nettbutikk') ? 'var(--v-secondary-text-base)' : 'var(--v-primary-base)'}`">
					<!-- Header tab items on homepages -->
					<div class="align-self-center" v-if="headerProps.layout != 'portal'">
						<span class="secondary-font" :style="nav.Link === $route.path ? useConstrastColors ? 'color: var(--v-primary-text-base)' : 'primary' : ''">{{ nav.Caption }}</span>
					</div>
					<!-- Header tab items on fixit.no -->
					<div class="align-self-center" v-else>
						<span class="secondary-font" :style="nav.Link === $route.path && !headerProps.atTop ? 'color: var(--v-secondary-base)' : ''">{{ nav.Caption }}</span>
					</div>
				</a>
			</v-tab>
		</v-tabs>
		<!-- Treatment 'Bestill time' dialog -->
		<choose-salon-dialog class="pr-4" :disabled="isDraft" :url="headerProps.fixitNoUrl" :treatment="treatment" :sites="sites" v-if="$route.params.treatment && isMounted &&  $vuetify.breakpoint.mdAndUp && headerProps.items.filter((i) => i.Visible && i.Type == 2).length" />
		<!-- Normal 'Bestill time' dialog -->
		<choose-salon-dialog class="pr-4" :disabled="isDraft" :url="headerProps.fixitNoUrl" :sites="sites" v-if="!$route.params.treatment && isMounted && $vuetify.breakpoint.mdAndUp && headerProps.items.filter((i) => i.Visible && i.Type == 2).length" />

		<v-toolbar-items class="fixit-no__toolbar-items" v-if="false">
			<v-icon size="26px" :color="!headerProps.atTop && headerProps.layout === 'portal' ? 'var(--v-primary-base)' : headerProps.atTop || (!headerProps.atTop && headerProps.layout !== 'portal') ? useConstrastColors ? 'var(--v-primary-text-base)' : 'primary' : ''" style="cursor: not-allowed">fxt-user</v-icon>
		</v-toolbar-items>
		<v-toolbar-items class="fixit-no__toolbar-items" v-else-if="!isNoShowPayment">
			<div class="d-flex flex-row align-center" style="height: 100%; width: 100%">
				<div v-show="!menu">
					<slot name="shopping-cart"></slot>
				</div>
				<v-btn v-if="!user.onlineSluttKundeId" @click="redirectToLogin()" x-small class="fixit-no__user-menu--activator-btn" height="100%" icon v-show="!menu">
				<v-icon id="user-button" size="26px" :color="!headerProps.atTop && headerProps.layout === 'portal' ? 'var(--v-secondary-base)' : headerProps.atTop || (!headerProps.atTop && headerProps.layout !== 'portal') ? useConstrastColors ? 'var(--v-primary-text-base)' : 'var(--v-primary-base)' : ''" style="cursor: pointer">fxt-user</v-icon>
						</v-btn>
				<v-menu
					v-else-if="user.onlineSluttKundeId"
					id="user-menu-dropdown"
					attach="#fixit-no__header"
					:transition="$vuetify.breakpoint.mdAndUp ? 'slide-y-transition' : 'slide-x-reverse-transition'"
					:close-on-content-click="false"
					offset-y
					tile
					bottom
					persistent
					v-model="userDialog"
					:content-class="$vuetify.breakpoint.mdAndUp ? 'fixit-no__user-menu' : 'fixit-no__user-menu__mobile'"
				>
					<template v-slot:activator="{ attrs, on }">
						<!-- TODO: Implement image editor/uploader and swap this user icon for the user's actual image/avatar -->
						<v-btn v-bind="attrs" v-on="on" x-small class="fixit-no__user-menu--activator-btn" height="100%" icon v-show="!menu">
							<!-- <v-avatar color="primary" size="40px">
								<v-icon size="36px" color="var(--v-secondary-base)">fxt-user</v-icon>
							</v-avatar> -->
							<div class="fixit-no__user-menu--logged-in-avatar" :style="'cursor: pointer; color: ' + (!headerProps.atTop && headerProps.layout === 'portal' ? `${headerProps.isProfile ? 'var(--v-primary-base)' : 'var(--v-secondary-base)'}` : headerProps.atTop && headerProps.layout === 'portal' ? 'primary' : !headerProps.atTop && headerProps.layout !== 'portal' && !userDialog ? useConstrastColors ? 'var(--v-primary-text-base)' : 'var(--v-primary-base)' : !headerProps.atTop && headerProps.layout !== 'portal' && userDialog ? useConstrastColors ? 'var(--v-primary-text-base)' : 'primary' : '')">
								<span class="fixit-no__user-menu--logged-in-avatar__initials">{{user.firstName[0] + user.lastName[0]}}</span>
							</div>
							<!-- <v-icon size="26px" :color="!headerProps.atTop && headerProps.layout === 'portal' ? `${headerProps.isProfile ? 'var(--v-primary-base)' : 'var(--v-secondary-base)'}` : headerProps.atTop && headerProps.layout === 'portal' ? 'primary' : !headerProps.atTop && headerProps.layout !== 'portal' && !userDialog ? useConstrastColors ? 'var(--v-primary-text-base)' : 'primary' : !headerProps.atTop && headerProps.layout !== 'portal' && userDialog ? useConstrastColors ? 'var(--v-primary-text-base)' : 'primary' : ''" style="cursor: pointer">fxt-user</v-icon> -->
						</v-btn>
					</template>
					<user-menu v-if="userDialog" :useOldNavigation="useOldNavigation" :user="user" :hideRedirectButton="false" :layout="headerProps.layout" @logout="logout()" @close-menu="userDialog = false" :isProfile="headerProps.isProfile"></user-menu>
				</v-menu>
			</div>
		</v-toolbar-items>
	</v-app-bar>
</template>
<script>
import { Header } from '../models';
import { waitFor } from "vue-wait";
import { UserMenu, ChooseSalonDialog } from './Common/CommonComponents';
export default {
	props: {
		/**
		 * Options for integrated FixitNoHeader component
		 *
		 * required :
		 *  @param {apiUrl} apiUrl url endpoint for login
		 *
		 * optional :
		 *  @param {headerColors} headerColors  default ["#BFE5E8", "#EFDDD1"] ;
		 *  @param {height} height  default 70 ;
		 *  @param {elevation} elevation  default 3 ;
		 *  @param {items} items  default [] ;
		 *  @param {layout} layout  default 'chain' ;
		 *  @param {atTop} atTop  default false ;
		 * @see TheFixitNoHeader
		 */
		headerProps: {
			type: [Header, Object],
			default: function () {
				return new Header();
			},
		},
		/**
		 * Currently logged in user or empty object
		 * @see User
		 */
		activeUser: {
			type: Object,
			required: true,
		},

		fixitMenuValue: {
			type: Boolean,
			default: false,
		},

		fixitLoginDialog: {
			type: Boolean,
			default: false,
		},
		userMenu: {
			type: Boolean,
			default: false,
		},
		newRelease: {
			type: Boolean,
			default: false,
		},
		useOldNavigation: {
			required: false,
			default: false,
			type: Boolean
		}
	},
	name: 'TheAppBar',
	components: {
		UserMenu,
		ChooseSalonDialog,
	},
	
	data: () => ({
		treatment: null,
		isMounted: false,
	}),
	mounted() {
		this.isMounted = true;
	},
	computed: {
		activeTab() {
			// fixes slider position in case tabs weren't rendered
			if (this.$refs.tabs) this.$refs.tabs.callSlider();
			// if (this.$refs.tabs && this.headerProps.items.findIndex((x) => x.Link === this.$route?.path) != -1) this.$refs.tabs.change(this.headerProps.items.findIndex((x) => x.Link === this.$route?.path))
			return this.headerProps.items.findIndex((x) => x.Link === this.$route?.path);
		},
		useConstrastColors() {
			return this.headerProps.layout == 'chain' ? this.$store.getters['cmsConfigHomepage/primaryAndSecondaryAreEqual'] : false
		},
		home() {
			return this.$route?.path === '/';
		},
		user: {
			get() {
				return this.activeUser;
			},
			set(user) {
				// this.setUserMenuOffsetY(this.headerProps.height)
				this.loginDialog = false;
				// this.$emit("setUser", new User(user));
			},
		},
		loginDialog: {
			get() {
				return this.fixitLoginDialog;
			},
			set(value) {
				this.$emit('setLogin', value);
			},
		},
		userDialog: {
			get() {
				return this.userMenu;
			},
			set(value) {
				this.$emit('setUserMenu', value);
			},
		},
		menu: {
			get() {
				return this.fixitMenuValue;
			},
			set(value) {
				this.$emit('setMenu', value);
			},
		},
		isDraft() {
			return this.$store.getters['cmsConfigHomepage/isDraftMode']
		},
		isNoShowPayment() {
			return (this.$route.path.includes('/betaling') || this.$route.path.includes('/bekreftelse')) && (this.$route.path.includes('/ikke-mott') || this.$route.path.includes('/sen-kansellering'))
		},
		sites() {
			if (!(this.$router.currentRoute.path.includes('nettbutikk') || window.location.host.includes('profil.'))) {
				let selectedSalon = this.$store.getters['cart/getSelectedSalon']
				if (selectedSalon) {
					return this.headerProps.sites.filter(x => x.siteId === selectedSalon);
				} else {
					return this.headerProps.sites
				}
			} else return this.headerProps.sites
		}
	},
	methods: {
		redirectToLogin() {
			  const url = process.env.VUE_APP_B2C_LOGIN_URL 
   						 ?? this.$config.VUE_APP_B2C_LOGIN_URL;

			 window.location.href = url + '?returnUrl=' + window.location.href;
		},
		navigationAction(nav) {
			// this.$nuxt.$loading.start();
			this.$emit('close-profile')
			if (this.fixitMenuValue) {
				this.menu = false;
			}
			if (nav.Dialog) {
				this[nav.DialogVariable] = true;
			} else if (nav.isInternal) {
				this.$router.push(nav.Link);
			} else if (nav.Link && nav.OpenInNewWindow) {
				window.open(nav.Link);
			} else if (nav.Caption == 'Nettbutikk') {
				window.open(`${process.env.VUE_APP_FIXIT_NO_URL || this.$config.PORTAL_URL}${nav.Link}`, `${this.$config.PORTAL_URL ? '_blank' : '_self'}`)
			} else if (nav.Link.includes('/bedrift')) {
				window.open(`${process.env.VUE_APP_FIXIT_NO_URL}${nav.Link}`, '_self')
			} else if (nav.Caption == 'Kjøp gavekort') {
				window.open(`${process.env.VUE_APP_FIXIT_NO_URL}${nav.Link}`, '_self')
			} else if (nav.Caption == 'Steder') {
				window.open(`${process.env.VUE_APP_FIXIT_NO_URL}${nav.Link}`, '_self')
			} else if (nav.Caption == 'Behandlinger') {
				this.headerProps.layout == 'portal' ? window.open(`${process.env.VUE_APP_FIXIT_NO_URL}${nav.Link}`, '_self') : this.$router.push('/behandlinger')
			} else if (nav.Caption == 'Min side') {
				this.$emit('set-profile', true)
			}
			else {
				this.$router.push(nav.Link)
			}
			// this.$nuxt.$loading.finish();
		},
			openLoginDialog() {
			this.$emit('open-login-dialog');
		},
		logout() {
			this.$emit('logout');
		},
		/**
		 * Set top position for user menu dropdown based on the header's height.
		 * Header height is set in the headerProps.height, and is being watched.
		 */
		setUserMenuOffsetY(value) {
			if (document || typeof process != undefined) {
				var headermenu = document.getElementsByClassName('fixit-no__user-menu').length ? document.getElementsByClassName('fixit-no__user-menu') : document.getElementsByClassName('fixit-no__user-menu__mobile')
				for(var i = 0; i < headermenu.length; i++)
				{
					headermenu[i].style.top = `${value}px`;
					headermenu[i].style.maxHeight = `calc(100vh - ${value}px)`;
					if (value < 120) {
						headermenu[i].style.borderTop = `none`;
					} else {
						headermenu[i].style.borderTop = `3px solid var(--v-primary-base)`;
					}
				}
			}
		},
		waitFor,
	},
	watch:{
		$route (to, from){
			if (to.params.treatment) {
				waitFor(`fetch treatment`, async function () {
					this.treatment = await this.$store.dispatch("treatments/fetchTreatment", to.params.id)
				}).apply(this);
			}
		},
		"headerProps.height": {
			handler(val) {
				this.setUserMenuOffsetY(val)
			},
			deep: true,
			immediate: true
		}
	} 
};
</script>
